import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette } = lightTheme;

export const tableBorderColor = {
  border: `0.063rem solid ${palette.grey['200']}`
};

const styles: Record<string, SxProps> = {
  headingbox: {
    mb: '2.5rem',
    '& p': {
      fontWeight: 400,
      fontSize: {
        xs: '0.875rem',
        md: '1.25rem'
      }
    }
  },
  endbox: {
    '& p': {
      color: palette.grey['400'],
      fontSize: {
        xs: '0.75rem',
        md: '1rem'
      }
    },
    '& span': {
      color: palette.grey['400']
    }
  },
  mainContainer: {
    background: palette.lightishAqua['400'],
    padding: {
      xs: '0.9375rem',
      md: '5rem'
    }
  },

  mainContainerAccordion: {
    background: palette.lightishAqua['400'],
    padding: '0',
    mt: '1rem',
    ml: '-1rem'
  },

  internalBox: {
    background: palette.grey['50'],
    padding: {
      xs: '1.5rem 1rem',
      md: '2.5rem 2.5rem'
    }
  },

  internalBoxAccordion: {
    background: palette.lightishAqua['400'],
    padding: '0'
  },

  btnContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: { xs: '100%', sm: 'auto' }
  },

  firstHeading: {
    fontSize: {
      xs: '1.5rem',
      md: '4rem'
    },
    lineHeight: {
      xs: '1.25rem',
      md: '2.5rem'
    },
    fontWeight: 700,
    color: palette.primary.main,
    mb: '1.5rem'
  },

  secondHeading: {
    fontSize: {
      xs: '1.5rem',
      md: '2.5rem'
    },
    lineHeight: {
      xs: '1.25rem',
      md: '2.5rem'
    },
    fontWeight: 700,
    color: palette.primary.main,
    mb: '1.5rem'
  },

  paragraph: {
    fontSize: {
      xs: '0.875rem',
      md: '1.25rem'
    },
    lineHeight: '1.25rem',
    color: palette.grey.main,
    mb: '1.5rem'
  },

  dash: {
    mb: '1.6rem',
    border: `0.063rem solid ${palette.primary['300']}`,
    opacity: '50%'
  },

  anchorTag: {
    color: palette.primary.main,
    textDecoration: 'underline'
  },

  // ==================================
  titleText: {
    fontSize: {
      xs: '1rem',
      md: '0.875rem'
    },
    lineHeight: {
      xs: '1.25rem',
      md: '1.045rem'
    },
    fontWeight: 800,
    display: 'block',
    mb: '1.5rem',
    width: {
      xs: '18rem',
      md: 'auto'
    }
  },

  smallHeading: {
    color: palette.primary.main,
    fontSize: '1.25rem',
    mb: '-1rem'
  },

  textFeeFullWidth: {
    fontSize: {
      xs: '1rem',
      md: '0.875rem'
    },
    lineHeight: '1.25rem',
    fontWeight: 400,
    color: palette.grey.main,
    mb: { xs: '1rem', md: '1.5rem' },
    width: '100%'
  },

  titleTextHelpFee: {
    fontSize: '1.25rem',
    lineHeight: {
      xs: '1.25rem',
      md: '2.5rem'
    },
    fontWeight: 700,
    color: palette.primary.main,
    display: 'block',
    mb: '1.5rem'
  },

  accHeadings: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    '& > span': {
      mb: {
        xs: '0.5rem',
        md: '1rem'
      }
    },
    mb: {
      xs: '0.5rem',
      md: '0rem'
    },
    justifyContent: 'space-between'
  },

  feeListDetails: {
    width: '100%',
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    '& > span': {
      mb: {
        xs: '0.5rem',
        md: '1rem'
      }
    },
    mb: {
      xs: '0.5rem',
      md: '0rem'
    },
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },

  textFee: {
    fontSize: {
      xs: '1rem',
      md: '0.875rem'
    },
    lineHeight: {
      xs: '1rem',
      md: '1.25rem'
    },
    fontWeight: 400,
    color: palette.grey.main,
    mb: { xs: '1rem', md: '1.5rem' },
    width: {
      xs: '20rem',
      md: '15rem'
    }
  },

  valueFee: {
    fontSize: {
      xs: '1rem',
      md: '0.875rem'
    },
    lineHeight: '1.25rem',
    fontWeight: 400,
    color: palette.grey.main,
    mb: { xs: '1rem', md: '1.5rem' },
    textAlign: {
      xs: 'left',
      md: 'right'
    },
    width: '10rem'
  },

  valueFeeEmpty: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 400,
    color: palette.grey.main,
    mb: { xs: '1rem', md: '1.5rem' },
    textAlign: {
      xs: 'left',
      md: 'right'
    }
  },

  // Table Styles ============================
  tableContainerBox: {
    overflowX: 'scroll',

    '& > div': {
      overflowX: 'initial'
    },

    '&::-webkit-scrollbar': {
      width: 5,
      height: 5
    },

    '::-webkit-scrollbar-thumb': {
      background: palette.primary.main,
      borderRadius: '1.5rem'
    }
  },
  tableMain: {
    ...tableBorderColor,
    background: palette.primary['400'],
    tableLayout: 'fixed',
    minWidth: '40rem'
  },

  tableHeading: {
    ...tableBorderColor,
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: '1rem',
    width: {
      xs: '9rem',
      md: 'auto'
    },
    color: palette.grey.main
  },

  tableBorder: {
    ...tableBorderColor
  },

  tableCell: {
    ...tableBorderColor,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
    color: palette.grey.main
  },

  tableRow: {
    '&:nth-child(odd) td, &:nth-child(odd) th': {
      backgroundColor: palette.grey['50']
    },
    '&:nth-child(even) td, &:nth-child(even) th': {
      backgroundColor: palette.primary['50']
    }
  }
};

export default styles;
